// filepath: client/src/routes/publicRoutes.js
import Home from '#client/pages/Home/Home';
import TokenHandler from '#client/services/TokenHandler';
import PublicVoucher from '#client/pages/Voucher/PublicVoucher';
import PrintableVoucher from '#client/pages/Voucher/PrintableVoucher';
import ErrorPage from '#client/pages/Error/ErrorPage';
import NoPermissions from '#client/pages/NoPermissions';

const publicRoutes = [
    {
        path: '/',
        element: <Home />,
        errorElement: <ErrorPage />,
    },
    {
        path: 'auth',
        element: <TokenHandler />,
    },
    {
        path: 'voucher/:code/:uuid',
        element: <PublicVoucher />,
    },
    {
        path: 'printable-voucher/:code/:uuid',
        element: <PrintableVoucher />,
    },
    {
        path: 'no-permissions',
        element: <NoPermissions />,
    },
];

export default publicRoutes;
